/**
 * Created by quikr on 1/3/17.
 */
const employees = [];
export default function employeeDetailReducers(state = [], action) {
  switch (action.type) {

    case 'GET_EMPLOYEE_DETAILS_SUCCESS':

      return action.employees;

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/Employee/employeeDetailsReducers.js
 **/